import { get, writable } from 'svelte/store';
import { setsDifference, getSetAItemsMissingInSetB } from '../service/util';
export class NewItemsStore {
    constructor(allItems, notifyIncrement, notifySnoozeAll) {
        this.allItems = allItems;
        this.notifyIncrement = notifyIncrement;
        this.notifySnoozeAll = notifySnoozeAll;
        this.unseenIdsStore = writable(new Set());
        this.unseenIds = new Set();
        this.seenIds = new Set();
        this.subscribe = this.unseenIdsStore.subscribe;
        allItems.subscribe(newAllItems => {
            const newlyUnseenItems = newAllItems.filter(newItem => !this.seenIds.has(newItem.id));
            this.unseenIds = new Set(newlyUnseenItems.map(item => item.id));
            this.updateStore();
        });
    }
    snoozeAll() {
        this.snoozeIds(this.unseenIds);
    }
    snoozeIds(itemIdsToSee) {
        itemIdsToSee.forEach(itemIdToSee => {
            this.seenIds.add(itemIdToSee);
            this.unseenIds.delete(itemIdToSee);
        });
        this.updateStore();
    }
    updateStore() {
        const unseenIdsBefore = get(this.unseenIdsStore);
        const unseenIdsNow = this.unseenIds;
        const anyChange = setsDifference(unseenIdsBefore, unseenIdsNow).size > 0;
        if (anyChange) {
            this.unseenIdsStore.set(new Set(unseenIdsNow));
            if (unseenIdsNow.size === 0) {
                this.notifySnoozeAll();
            }
            else {
                const anyIncrement = getSetAItemsMissingInSetB(unseenIdsBefore, unseenIdsNow).size > 0;
                if (anyIncrement) {
                    this.notifyIncrement(unseenIdsNow);
                }
            }
        }
    }
}
